<div class="row">
  <div class="col-md-6">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Role {{Title}}</h4>
        <div class="form-group">
          <label for="RoleName">Role Name *</label>
          <div class="input-group">

            <input type="text" class="required form-control" required id="RoleName" [(ngModel)]="Doc.RoleName"
              #RoleName="ngModel" aria-label="Role Name" placeholder="" />

          </div>
          <div [hidden]="RoleName.valid || RoleName.pristine" class="alert alert-danger">
            Role Name is required
          </div>
        </div>
        <div class="form-group">
          <label for="IsEnabled">IsEnabled</label>
          <ng-select [searchable]="false" [items]="Doc.ddlEnabled" id="IsEnabled" bindValue="value" bindLabel="text"
            [clearable]="false" [(ngModel)]="Doc.SelectEnabled">
          </ng-select>
        </div>
        <p>(*) Mandatory</p>
      </div>
      <div class="border-top">
        <div class="card-body">
          <button (click)="Cancel()" class="btn btn-outline-secondary" role="button">Cancel</button>
          <button (click)="Submit()" class="btn btn-success ml-1" role="button" [disabled]="isValid()">Submit</button>
        </div>
      </div>
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Container fluid  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- footer -->
  <!-- ============================================================== -->
  <footer class="footer text-center"></footer>
  <!-- ============================================================== -->
  <!-- End footer -->
  <!-- ============================================================== -->
</div>